import config from "./config";
import apiService from "./apiService";
export default {
  async getSuperannuationInformation(clientId) {
    let superannuationApiUrl = `${config.superannuationApiUrl}/${clientId}`;
    return apiService.get(superannuationApiUrl);
  },
  async saveSuperannuationInformation(superannuationModel, iceModel) {
    superannuationModel.ProjectionResult = iceModel;
    let payload = superannuationModel;

    let saveSuperannuationApiUrl = `${config.saveSuperannuationApiUrl}`;
    return apiService.post(saveSuperannuationApiUrl, payload);
  },
  async saveAsSuperannuationInformation(superannuationModel, iceModel) {
    superannuationModel.ProjectionResult = iceModel;
    let payload = {
      superFundDTO: superannuationModel,
    };
    let saveSuperannuationApiUrl = `${config.saveAsSuperannuationApiUrl}`;
    return apiService.post(saveSuperannuationApiUrl, payload);
  },
  async createCopyOfSuperannuation(apiModel) {
    let apiUrl = `${config.copySuperannuationApiUrl}`;
    return apiService.post(apiUrl, apiModel);
  },
  async deleteSuperannuation(superannuationGuid,encClientId) {
    let apiUrl = `${config.deleteSuperannuationApiUrl}/${superannuationGuid}/${encClientId}`;
    return apiService.delete(apiUrl);
  },
  async updateSuperannuation(superannuation) {
    let apiUrl = `${config.superannuationApiUrl}`;
    return apiService.put(apiUrl, superannuation);
  },
};
